import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { environment } from 'src/environments/environment';
import { Funds_Interface } from 'src/app/Interface/Funds_Interface';
import { LetterRequestCustomer_Funds_Interface } from 'src/app/Interface/LetterRequestCustomer_Funds_Interface';

@Injectable({
  providedIn: 'root'
})
export class FundsService {

  constructor(private http: HttpClient) { }

  GetRecord(): Observable<Array<User_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Funds").pipe(
      map(data => {
        return data as Array<User_Interface>
      })
    )
  }

  AddEditFunds(
    user_id: number,
    price: number,
    price_date: String,
    dsc: String): Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var model = {
      id :0,
      user_id :user_id,
      price :price,
      dsc :dsc,
    }

    var body = {
      Model :model,
      PriceDate:price_date,
    }

    return this.http.post(environment.BaseUrl + "Daro/Funds/AddEdit",body,{headers}).pipe(
      map(data=>{
        return data as any
      })
    )



  }


  DeleteFunds(id: number): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Funds/Delete?id=" + id ).pipe(
      map(data => {
        return data as any
      })
    )

  }

  GetDetail(id :Number): Observable<Array<Funds_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Funds/GetDetail?id="+id).pipe(
      map(data => {
        return data as Array<Funds_Interface>
      })
    )
  }

  GetDetailUser(): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Funds/GetDetailUser").pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetFundsSettle(StartSearchDate: String,
    EndSearchDate: String,
    PeriodDate: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Funds/GetFundsSettle?StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
      + "&PeriodDate=" + PeriodDate).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetFundsWithdraw(StartSearchDate: String,
    EndSearchDate: String,
    UserSearch: String,
    Status: number,
    PeriodDate: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Funds/GetFundsWithdraw?StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
      + "&UserSearch=" + UserSearch
      + "&Status=" + Status
      + "&PeriodDate=" + PeriodDate).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetReview(): Observable<Array<LetterRequestCustomer_Funds_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Funds/GetReview").pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_Funds_Interface>
      })
    )
  }

  AddEditFunds_Schedule(
    id: number,
    schedule_id: number,
    price: number,
    price_date: String,
    title_id: number,
    dsc: String,
    src: String): Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var model = {
      id :id,
      schedule_id :schedule_id,
      title_id :title_id,
      price :price,
      src :src,
      dsc :dsc,
    }

    var body = {
      Model :model,
      PriceDate:price_date,
    }

    return this.http.post(environment.BaseUrl + "Daro/Funds/AddEditSchedule",body,{headers}).pipe(
      map(data=>{
        return data as any
      })
    )



  }

  GetSchedule(id :Number): Observable<Array<LetterRequestCustomer_Funds_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Funds/GetSchedule?id="+id).pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_Funds_Interface>
      })
    )
  }

  GetCount(): Observable<Array<number>> {
    return this.http.get(environment.BaseUrl + "Daro/Funds/GetCount").pipe(
      map(data => {
        return data as Array<number>
      })
    )
  }

  DeleteSchedule(id: number): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Funds/DeleteSchedule?id=" + id ).pipe(
      map(data => {
        return data as any
      })
    )

  }

  AnswerReview(id: number,status: number, dsc: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Funds/AnswerReview?id=" + id
      + "&status=" + status
      + "&dsc=" + dsc
      ).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile(body) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Funds/Upload", body).pipe(
      map(data => {

        return data
      })
    )
  }

}
